/**
 * G27 — raw binary/text vector artifacts the converter may emit today but the
 * viewer must not ingest via `endpoints.features` + JSON.parse. Post-handover
 * converter work should emit PMTiles or GeoJSON instead.
 *
 * These constants are viewer-internal and intentionally separate from the
 * platform SDK stub (`artifactContract.ts`) so the drift test does not flag
 * them as absent from the SDK source.
 */

export const VIEWER_UNSUPPORTED_BINARY_VECTOR_KINDS = [
  "flatgeobuf",
  "geoparquet",
  "dxf",
] as const;

export type ViewerUnsupportedBinaryVectorKind =
  (typeof VIEWER_UNSUPPORTED_BINARY_VECTOR_KINDS)[number];

export const VIEWER_UNSUPPORTED_BINARY_VECTOR_MESSAGE =
  "Unsupported format — convert to PMTiles or GeoJSON before loading in the viewer.";

export function isViewerUnsupportedBinaryVectorKind(
  kind: string | undefined,
): kind is ViewerUnsupportedBinaryVectorKind {
  return (
    kind != null
    && (VIEWER_UNSUPPORTED_BINARY_VECTOR_KINDS as readonly string[]).includes(kind)
  );
}
